module.exports = __webpack_public_path__ + "odinstatic/v13.0.1/media/placement.a1117be5.svg";